import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import "./assets/css/bootstrap.min.css";
import './assets/css/style.css'
import './assets/css/common.css'
import './assets/css/sidebar.css'
import './assets/css/rtl.css'
import './assets/css/responsive.css'
import WelcomeIndex from './pages/welcome/welcomeindex';
import SidebarFile from './pages/commoncomponents/sidebarfile';
import Find from './pages/main/find';
import People from './pages/main/people';
import PeopleDetail from './pages/main/peopledetail';
import Messgae from './pages/main/message';
import Feeds from './pages/main/feeds';
import Settings from './pages/main/settings';
import Visitors from './pages/main/visitor';
import VisitorDetail from './pages/main/visitordetail';
import Matches from './pages/main/matches';
import MatchesDetail from './pages/main/matchesdetail';
import SuperLike from './pages/main/superlike';
import SuperLikeDetail from './pages/main/superlikedetail';
import Like from './pages/main/like';
import LikeDetail from './pages/main/likedetail';
import SuperLikeNot from './pages/main/nosuperlike';
import Help from './pages/main/help';
import Profile from './pages/main/profile';
import EditPhoto from './pages/main/profile/components/editphoto';
import Nofind from './pages/main/nofind';
import Signupfirebase from './pages/welcome/Signupfirebase';
import Editphonefirebase from './pages/main/profile/components/Editphonefirebase';
import Facerecognition from './pages/commoncomponents/facerecognition';
import Coupon from './pages/main/coupon'
import Payment from './pages/main/plan/payment'
import Superlikepayment from './pages/main/plan/superlikepayment'
import Boostpayment from './pages/main/plan/boostpayment'
import Verify from './pages/welcome/verify';

class App extends Component {

  render() {

    return (
      <div className="App">
        <Router basename={'/web'}>
          <div className='whole_layout'>
            <Switch>
              <Route exact path="/" component={WelcomeIndexWithoutSidebar} />
              <Route exact path="/coupon/:type" component={Coupon} />
              <Route exact path="/coupon/" component={Coupon} />
              <Route exact path="/Signupfirebase" component={Signupfirebase} />
              <Route exact path="/Editphonefirebase" component={Editphonefirebase} />
              <Route exact path="/Facerecognition" component={Facerecognition} />
              <Route exact path="/payment" component={Payment} />
              <Route exact path="/superlikepayment" component={Superlikepayment} />
              <Route exact path="/boostpayment" component={Boostpayment} />
              <Route exact path="/verify" component={Verify} />
              <Route component={SidebarFile} />
            </Switch>
            <Switch>
              <Route exact path="/find" component={Find} />
              <Route exact path="/people" component={People} />
              <Route exact path="/peopledetail/:userId" component={PeopleDetail} />
              <Route exact path="/message/:userId/:chatId" component={Messgae} />
              <Route exact path="/message" component={Messgae} />
              <Route exact path="/feeds" component={Feeds} />
              <Route exact path="/settings" component={Settings} />
              <Route exact path="/visitor" component={Visitors} />
              <Route exact path="/visitordetail/:userId" component={VisitorDetail} />
              <Route exact path="/matches" component={Matches} />
              <Route exact path="/matchesdetail/:userId" component={MatchesDetail} />
              <Route exact path="/superlike" component={SuperLike} />
              <Route exact path="/superlikedetail/:userId" component={SuperLikeDetail} />
              <Route exact path="/like" component={Like} />
              <Route exact path="/likedetail/:userId" component={LikeDetail} />
              <Route exact path="/nosuperlike" component={SuperLikeNot} />
              <Route exact path="/help" component={Help} />
              <Route exact path="/profile" component={Profile} />
              <Route exact path="/editphoto" component={EditPhoto} />
              <Route exact path="/nofind" component={Nofind} />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

const WelcomeIndexWithoutSidebar = () => (
  <div>
    <WelcomeIndex />
  </div>
);

export default App;
